import { Condition, DepositType } from '@urbanx/agx.campaigns.client';
import { useMemo } from 'react';
import {
  ConditionFromOptions,
  InitialDepositOnDateOptions,
  BalanceDepositOnDateOptions,
  InitialDepositNDaysOptions,
  BalanceDepositNDaysOptions,
} from './ConditionFromOptions';

export const useFormConditionDateOptions = (
  dateOptions: Condition[],
  useOnDateVariant = false,
  depositType?: DepositType
) => {
  return useMemo(() => {
    let optionsToUse = ConditionFromOptions;

    // For deposits, choose appropriate options based on type and segment
    if (depositType !== undefined) {
      if (useOnDateVariant) {
        // "On..." segment
        optionsToUse =
          depositType === DepositType.Initial
            ? InitialDepositOnDateOptions
            : BalanceDepositOnDateOptions;
      } else {
        // "# days from..." segment
        optionsToUse =
          depositType === DepositType.Initial
            ? InitialDepositNDaysOptions
            : BalanceDepositNDaysOptions;
      }
    }

    return optionsToUse.filter((option) => {
      if (option.value === '') return true;

      // For OnDate variant, include OnDate when OnDate or NdaysFromDate is in dateOptions
      if (useOnDateVariant && option.value === Condition.OnDate) {
        return (
          dateOptions.includes(Condition.OnDate) || dateOptions.includes(Condition.NdaysFromDate)
        );
      }

      return dateOptions.includes(option.value as Condition);
    });
  }, [dateOptions, useOnDateVariant, depositType]);
};
